import React from 'react';

import Badge from 'ff/debrief/common/components/Badge';

type Props = {
    ownerUsername: string;
};

const OwnedByBadge: React.FC<Props> = props => {
    return (
        <Badge
            testId="owned-by"
            label={props.ownerUsername}
            margin="4px 0 0"
            color="light-gray"
            icon="shared"
        />
    );
};

export default OwnedByBadge;
